import React, { Component } from "react";
import {
    Box,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Link as MuiLink
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { listGroups } from "./apigroup";
import { isAuthenticated } from "../auth";

class Groups extends Component {

    constructor() {
        super();
        this.state = {
            groups: [],
            userId: isAuthenticated() && isAuthenticated().userId,
            token: isAuthenticated().token,
            userEmail: isAuthenticated().email,
        };
    }


    loadGroups = () => {
        listGroups(this.state.token).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({ groups: data });
            }
        });
    };

    componentDidMount() {
        this.loadGroups();
    }


    render() {
        return (
            <Box>
                {this.state.groups.map((group, i) => (
                    <Accordion key={i}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${i}-content`}
                            id={`panel${i}-header`}
                        >
                            <MuiLink
                                href={`/singlegroup/${group._id}`}
                                underline="hover"
                                sx={{ fontWeight: 'bold' }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {group.name}
                            </MuiLink>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                {group.description}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
        )
    }
};

export default Groups;